module.exports = __webpack_public_path__ + "static/img/iphone_ldttitle1.8f2c64d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_ldttitle1.png
// module id = i2uc
// module chunks = 0